import { useIsFetching } from '@tanstack/react-query';
import { CellLayout, CellLayoutRow } from './CellLayout';
import Skeleton from '@mui/material/Skeleton';
import { rSimProductsQueries } from 'src/rSimInventory/utils/rsimProductsQueries';
import { TextCell } from './TextCell';

export const LastPollingTimeStampCellCell = ({ value }: { value: string | null }) => {
  const isFetching = useIsFetching({
    queryKey: rSimProductsQueries.lastPollingTimestamps({ euiccs: [] }),
  });

  if (isFetching) {
    return (
      <CellLayout>
        <CellLayoutRow>
          <Skeleton height={18} />
        </CellLayoutRow>
      </CellLayout>
    );
  }

  return <TextCell value={value} />;
};
